import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './LandingComponents/Navbar';
import Footer from './LandingComponents/Footer';
import HomeContent from './LandingComponents/HomeContent';

const LandingPage = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return (
    <div className="min-h-screen flex flex-col font-outfit">
      <Navbar />
      <main className="flex-grow">
        <HomeContent />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
